import axiosIns from '../../helpers/axios/axios'
import { TournamentRow, types } from '../entities/Tournament';

export const state = {
  tableData: [],
  positions: [],
  retries: [],
  operators: [],
  success: false,
  message: '',
  types
}

export const getters = {
  getData(state) {
    return state.tableData;
  },
  getPositions(state) {
    return state.positions;
  },
  getRetries(state) {
    return state.retries;
  },
  getOperators(state) {
    return state.operators;
  },
  getFields() {
    return [
      { key: 'name', label: 'NOMBRE' },
      { key: 'game', label: 'JUEGO' },
      { key: 'logo', label: 'LOGO' },
      { key: 'winningAmount', label: 'MONTO A REPARTIR' },
      { key: 'type', label: 'TIPO DE TORNEO' },
      { key: 'start_date', label: 'FECHA DE INICIO' },
      { key: 'actions', label: 'ACCIONES' },
    ];
  },
  isSuccess(state) {
    return state.success;
  },
  getMessage(state) {
    return state.message;
  },
}

export const mutations = {
  setSuccess(state, value) {
    state.success = value;
  },
  setTableData(state, data) {
    state.tableData = data;
  },
  setMessage(state, message) {
    state.message = message;
  },
  setPositions(state, positions) {
    state.positions = positions;
  },
  setRetries(state, retries) {
    state.retries = retries;
  },
  setOperators(state, retries) {
    state.operators = retries;
  }
}

export const actions = {
  async fetchTournaments({ commit }, filter) {

    const {
      page = 1,
      limit = 10
    } = filter

    try {
      const { data, status } = await axiosIns.get('/v2/tournaments', {
        params: {
          page,
          limit
        }
      });

      if (status !== 200) throw new Error('Failed to fetch tournaments');

      commit('setTableData', data.data.map(tournament => new TournamentRow(tournament)));
    } catch (error) {
      console.log('ERROR FETCHING TOURNAMENTS', error);
      commit('setTableData', []);
    }
  },
  async createTournament({ commit }, tournament) {
    try {
      const { status } = await axiosIns.post('/v2/tournaments', tournament);

      if (status !== 201) throw new Error('Failed to create tournament');

      commit('setMessage', 'Torneo creado exitosamente');
      commit('setSuccess', true);
    } catch (error) {
      console.log('ERROR CREATING TOURNAMENT', error);
      commit('setSuccess', false);
      commit('setMessage', 'Error al crear el torneo');
    }
  },
  async updateTournament({ commit }, tournament) {
    try {
      const { status } = await axiosIns.put(`/v2/tournaments/${tournament.id}`, tournament);

      if (status !== 200) throw new Error('Failed to update tournament');

      commit('setMessage', 'Torneo actualizado exitosamente');
      commit('setSuccess', true);
    } catch (error) {
      console.log('ERROR UPDATING TOURNAMENT', error);
      commit('setSuccess', false);
      commit('setMessage', 'Error al actualizar el torneo');
    }
  },
  async deleteTournament({ commit }, tournamentId) {
    try {
      const { status } = await axiosIns.delete(`/v2/tournaments/${tournamentId}`);

      if (status !== 204) throw new Error('Failed to delete tournament');

      commit('setMessage', 'Torneo eliminado exitosamente');
      commit('setSuccess', true);
    } catch (error) {
      console.log('ERROR DELETING TOURNAMENT', error);
      commit('setSuccess', false);
      commit('setMessage', 'Error al eliminar el torneo');
    }
  },
  async fetchPositions({ commit }, tournamentId) {
    try {
      const { data, status } = await axiosIns.get(`/v2/tournaments-positions`, {
        params: {
          tournament: tournamentId,
          page: 1,
          limit: 10000
        }
      });

      if (status !== 200) throw new Error('Failed to fetch positions');

      commit('setPositions', data.data.map(position => ({
        id: position._id,
        ...position
      })));
    } catch (error) {
      console.log('ERROR FETCHING POSITIONS', error);
      commit('setPositions', []);
    }
  },
  async addPosition({ commit }, { position }) {
    try {
      const { status } = await axiosIns.post('v2/tournaments-positions', position);

      if (status !== 201) throw new Error('Failed to add position');

      commit('setSuccess', true);
      commit('setMessage', 'Posicion agregada exitosamente');
    } catch (error) {
      commit('setSuccess', false);
      commit('setMessage', 'Error al agregar la posicion');
    }
  },
  async updatePosition({ commit }, { position }) {
    try {
      const { status } = await axiosIns.put(`v2/tournaments-positions/${position.id}`, position);

      if (status !== 200) throw new Error('Failed to update position');

      commit('setSuccess', true);
      commit('setMessage', 'Posicion actualizada exitosamente');
    } catch (error) {
      commit('setSuccess', false);
      commit('setMessage', 'Error al actualizar la posicion');
    }
  },
  async deletePosition({ commit }, positionId) {
    try {
      const { status } = await axiosIns.delete(`v2/tournaments-positions/${positionId}`);

      if (status !== 204) throw new Error('Failed to delete position');

      commit('setSuccess', true);
      commit('setMessage', 'Posicion eliminada exitosamente');
    } catch (error) {
      commit('setSuccess', false);
      commit('setMessage', 'Error al eliminar la posicion');
    }
  },
  async fetchRetries({ commit }, tournamentId) {
    try {
      const { data, status } = await axiosIns.get(`/v2/tournaments-retrys`, {
        params: {
          tournament: tournamentId,
          page: 1,
          limit: 10000
        }
      });

      if (status !== 200) throw new Error('Failed to fetch retries');

      commit('setRetries', data.data.map(retry => ({
        id: retry._id,
        ...retry
      })));
    } catch (error) {
      console.log('ERROR FETCHING RETRIES', error);
      commit('setRetries', []);
    }
  },
  async createRetries({ commit }, { retries }) {
    try {
      const { status } = await axiosIns.post('v2/tournaments-retrys', retries);

      if (status !== 201) throw new Error('Failed to create retries');

      commit('setSuccess', true);
      commit('setMessage', 'Reintentos creados exitosamente');
    } catch (error) {
      commit('setSuccess', false);
      commit('setMessage', 'Error al crear reintentos');
    }
  },
  async updateRetries({ commit }, { retries }) {
    try {
      const { status } = await axiosIns.put(`v2/tournaments-retrys/${retries.id}`, retries);

      if (status !== 200) throw new Error('Failed to update retries');

      commit('setSuccess', true);
      commit('setMessage', 'Reintentos actualizados exitosamente');
    } catch (error) {
      commit('setSuccess', false);
      commit('setMessage', 'Error al actualizar reintentos');
    }
  },
  async deleteRetries({ commit }, retriesId) {
    try {
      const { status } = await axiosIns.delete(`v2/tournaments-retrys/${retriesId}`);

      if (status !== 204) throw new Error('Failed to delete retries');

      commit('setSuccess', true);
      commit('setMessage', 'Reintentos eliminados exitosamente');
    } catch (error) {
      commit('setSuccess', false);
      commit('setMessage', 'Error al eliminar reintentos');
    }
  },
  async fetchOperators({ commit }, tournamentId) {
    try {
      const { data, status } = await axiosIns.get(`/v2/tournaments-operators`, {
        params: {
          tournament: tournamentId,
          page: 1,
          limit: 10000
        }
      });

      if (status !== 200) throw new Error('Failed to fetch operators');

      commit('setOperators', data.data.filter(operator => operator.tournament === tournamentId).map(operator => ({
        id: operator._id,
        ...operator
      })));
    } catch (error) {
      commit('setOperators', []);
    }
  },
  async assignOperator({ commit }, { values, tournament }) {
    try {

      const promises = values.map(({ operator }) => {
        return axiosIns.post('v2/tournaments-operators', {
          tournament,
          operator
        });
      });

      await Promise.all(promises);

      commit('setSuccess', true)
    } catch (error) {
      commit('setSuccess', false)
    }
  },
  async removeOperator({ commit }, { id }) {
    try {

      const { status } = await axiosIns.delete(`v2/tournaments-operators/${id}`)

      if (status > 204) throw new Error('Error removing operator from tournament')

      commit('setSuccess', true)
      commit('setMessage', 'Operador eliminado');
    } catch (err) {
      commit('setSuccess', false)
      commit('setMessage', 'Error eliminando operador del torneo');
    }
  }
}